import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';

interface StateProps {
  isLoading: boolean;
  lastRunCreditsCharged?: number;
  isOpenRequested: boolean;
}

const initialState: StateProps = {
  isLoading: false,
  isOpenRequested: false,
};

export const emailMakerAiRedesignPromptBoxSlice = createSlice({
  name: 'emailMakerAiRedesignPromptBox',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLastRunCreditsCharged: (state, action: PayloadAction<number | undefined>) => {
      state.lastRunCreditsCharged = action.payload;
    },
    requestAiRedesignModalOpen: (state) => {
      state.isOpenRequested = true;
    },
    consumeAiRedesignModalOpenRequest: (state) => {
      state.isOpenRequested = false;
    },
  },
});

export const {setIsLoading, setLastRunCreditsCharged, requestAiRedesignModalOpen, consumeAiRedesignModalOpenRequest} = emailMakerAiRedesignPromptBoxSlice.actions;

export const emailMakerAiRedesignPromptBoxReducer = emailMakerAiRedesignPromptBoxSlice.reducer;
